import axios from "axios";

export const TOKEN_KEY = "matiq_token";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY) && !err.config.url.startsWith("/auth/") && !err.config.url.startsWith("/admin")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message === "Network Error" ? "Network error. Check your connection." : "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ").replace(/^Value error, /, "");
  return detail.msg || String(detail);
}

export const userTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const formatDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });

export const titleCase = (s = "") => s.replace(/\b\w/g, (c) => c.toUpperCase());
